import auth from "@/modules/auth/services/auth";
import axios from "axios";
import router from "@/modules/global/router";
import store from "@/modules/global/stores";
// eslint-disable-next-line no-unused-vars

var http = axios.create({
    baseURL: process.env.API_BASE_URL + "tryout-service",
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token"),
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    },
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        }),
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        }),
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                })
                .catch(function (err) {
                    var failedRequest = err.config;
                    // eslint-disable-next-line no-undef
                    var token = JSON.parse(localStorage.getItem("token")).value;
                    auth.doLogout(token, function (result) {
                        if (result.success) {
                            localStorage.clear();
                            store.commit("auth_destroyed");
                            router.push("/");
                        }
                    });

                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    },
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function getTryoutById(id, callback) {
    var config = getConfig();
    http.get("/tryout/" + id, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListTryout(pagination, search, callback) {
    var config = getConfig();
    var url = "/admin/tryouts?";

    if (
        pagination &&
        pagination.perPage !== undefined &&
        pagination.perPage !== null
    )
        url += "per_page=" + pagination.perPage;
    if (
        pagination &&
        pagination.currentPage !== undefined &&
        pagination.currentPage !== null
    )
        url += "&page=" + pagination.currentPage;
    if (
        pagination &&
        pagination.sortMode !== undefined &&
        pagination.sortMode !== null
    ) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.query && search.by)
        url +=
            "&search=" +
            encodeURIComponent(search.query) +
            "&search_by=" +
            search.by;

    http.get(url, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListPublishedTryout(pagination, search, callback) {
    var config = getConfig();
    var url = "/admin/tryouts?status=PUBLISHED&create_group=true";

    if (
        pagination &&
        pagination.perPage !== undefined &&
        pagination.perPage !== null
    )
        url += "&per_page=" + pagination.perPage;
    if (
        pagination &&
        pagination.currentPage !== undefined &&
        pagination.currentPage !== null
    )
        url += "&page=" + pagination.currentPage;
    if (
        pagination &&
        pagination.sortMode !== undefined &&
        pagination.sortMode !== null
    ) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.query && search.by)
        url += "&search=" + search.query + "&search_by=" + search.by;

    http.get(url, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data.tryouts,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function saveTryout(tryout, callback) {
    var config = getConfig();
    http.post("/tryout", tryout, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function duplicateTryout(tryout, callback) {
    var config = getConfig();
    http.post(`/tryout/${tryout.id}/duplicate`, tryout, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateTryout(tryout, callback) {
    var config = getConfig();
    http.put("/tryout/" + tryout.id, tryout, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function saveSubtest(subtest, callback) {
    var config = getConfig();
    http.post("/subtest", subtest, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateSubtest(subtest, callback) {
    var config = getConfig();
    http.put("/subtest/" + subtest.id, subtest, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function reviewTryout(id, callback) {
    var config = getConfig();
    http.put("/tryout/" + id + "/review", {}, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function publishTryout(id, callback) {
    var config = getConfig();
    http.put("/tryout/" + id + "/publish", {}, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function draftTryout(id, callback) {
    var config = getConfig();
    http.put("/tryout/" + id + "/draft", {}, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListOfTryoutGroups(pagination, search, params, callback) {
    var config = getConfig();
    var url = "/tryout_groups?";

    if (
        pagination &&
        pagination.perPage !== undefined &&
        pagination.perPage !== null
    )
        url += "per_page=" + pagination.perPage;
    if (
        pagination &&
        pagination.currentPage !== undefined &&
        pagination.currentPage !== null
    )
        url += "&page=" + pagination.currentPage;
    if (
        pagination &&
        pagination.sortMode !== undefined &&
        pagination.sortMode !== null
    ) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.by)
        url += "&search=" + search.query + "&search_by=" + search.by;
    if (params) config.params = params;

    http.get(url, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createTryoutGroup(data, callback) {
    var config = getConfig();
    http.post("/tryout_group", data, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getTryoutGroup(id, callback) {
    var config = getConfig();
    http.get("/tryout_group/" + id, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editTryoutGroup(id, data, callback) {
    var config = getConfig();
    http.put("/tryout_group/" + id, data, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteTryoutGroup(id, callback) {
    var config = getConfig();
    http.delete("/tryout_group/" + id, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                message: error.message,
            });
        });
}

function publishTryoutGroup(id, callback) {
    var config = getConfig();
    http.put("/tryout_group/" + id + "/publish", {}, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function unPublishTryoutGroup(id, callback) {
    var config = getConfig();
    http.put("/tryout_group/" + id + "/draft", {}, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addTryoutIntoGroup(tryoutId, groupId, callback) {
    var config = getConfig();
    http.put("tryout/" + tryoutId + "/group/" + groupId, {}, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function removeTryoutFromGroup(tryoutId, groupId, callback) {
    var config = getConfig();
    http.delete("/tryout/" + tryoutId + "/group/" + groupId, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListOfTryoutSeries(callback) {
    var config = getConfig();
    http.get("/series", config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createTryoutSeries(data, callback) {
    var config = getConfig();
    http.post("/series", data, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data ? response.data : "Berhasil",
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editTryoutSeries(data, callback) {
    var config = getConfig();
    http.put("/series/" + data.id, data, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data ? response.data : "Berhasil",
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getTryoutSeries(id, callback) {
    var config = getConfig();
    http.get("/series/" + id, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function attachGroupIntoSeries(groupId, seriesId, callback) {
    var config = getConfig();
    var url = "/tryout_group/" + groupId + "/series/" + seriesId;
    http.put(url, {}, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function dettachGroupFromSeries(groupId, seriesId, callback) {
    var config = getConfig();
    var url = "/tryout_group/" + groupId + "/series/" + seriesId;
    http.delete(url, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function resetStateTryout(body, callback) {
    var config = getConfig();
    http.post("/membership/reset", body, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteTryoutSerial(id, callback) {
    var config = getConfig();
    http.delete("/series/" + id, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    getTryoutById,
    getListTryout,
    getListPublishedTryout,
    saveTryout,
    duplicateTryout,
    updateTryout,
    reviewTryout,
    publishTryout,
    draftTryout,
    saveSubtest,
    updateSubtest,
    getListOfTryoutGroups,
    createTryoutGroup,
    editTryoutSeries,
    getTryoutGroup,
    editTryoutGroup,
    deleteTryoutGroup,
    publishTryoutGroup,
    unPublishTryoutGroup,
    addTryoutIntoGroup,
    removeTryoutFromGroup,
    getListOfTryoutSeries,
    createTryoutSeries,
    getTryoutSeries,
    attachGroupIntoSeries,
    dettachGroupFromSeries,
    resetStateTryout,
    deleteTryoutSerial,
};



// WEBPACK FOOTER //
// ./src/modules/tryout/services/tryout.js